// AUTO-GENERATED by sync-icons — do not edit.
import ErrorIconSvg from './ErrorIcon';
import InfoIconSvg from './InfoIcon';
import SuccessIconSvg from './SuccessIcon';
import WarningIconSvg from './WarningIcon';
import { withIconWrapper } from '../../IconWrapper';
export const ErrorIcon = withIconWrapper(ErrorIconSvg);
export const InfoIcon = withIconWrapper(InfoIconSvg);
export const SuccessIcon = withIconWrapper(SuccessIconSvg);
export const WarningIcon = withIconWrapper(WarningIconSvg);
